import { createEffect } from 'effector';
import { api } from '../../api/axiosinstance.js';

export const loginFx = createEffect().use(async (payload) => {
  return (await api(false).post('/access/login', payload)).data;
});

export const logoutFx = createEffect().use(async () => {
  return (await api(true).post('/access/logout')).data;
});

export const getUserInfoFx = createEffect().use(async () => {
  return (await api(true).get('/access/info')).data;
});
